export default __webpack_public_path__ + "static/media/Briefcase_News_Privacy_and_cookies_policy_10_March_2020.0ce2563a.pdf";